import React from "react";
import "../../App.css";
import { NavigationContext } from "../../NavigationContext";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  RowStyleModule,
} from "ag-grid-community";
import Button from "react-bootstrap/Button";
import { getNotifictionDateFormat } from "../../utils/Helper";
import { ADMIN_TYPE, GRID_COLUMN_EMPTY_ICONS } from "../../utils/Constants";
import PropTypes from "prop-types";
import { ROUTES } from "../../config/routes";
import { colors } from "../../config/colors";
import { LandingAGgridStyled } from "./styled";
import { BoxSelectedLogo, SideBarAddLogo } from "../../assets/icons";
import { Typography } from "@mui/material";
import { FONT_WEIGHT_BOLD } from "../../config/styles";

class LandingPageAGgrid extends React.Component {
  static contextType = NavigationContext;
  constructor(props) {
    super(props);
    this.adminType = localStorage.getItem("role");
    this.onGridReady = this.onGridReady.bind(this);
    this.state = {
      show: false,
      studentUpdateList: [],
      merchantIdGlobal: "",
      studentUpdateListStudentId: "",
      studentUpdateschoolId: "",
      studentUpdateMerchantId: "",
      studentUpdateSchoolName: "",
      studentUpdateSchoolPhoneNum: "",
      studentUpdateFirstNameVal: "",
      studentUpdateLastName: "",
      studentUpdateMiddleNameVal: "",
      studentUpdateGivenName: "",
      studentUpdateEmiratesId: "",
      studentUpdateGrade: "",
      studentUpddateDivision: "",
      studentUpdateDateOfBirth: "",
      studentUpdateNationality: "",
      studentUpdateProductName: "",
      studentUpdateOutstandingAmount: "",
      studentUpdateFatherName: "",
      studentUpdateMotherName: "",
      studentUpdateParentId: "",
      studentUpdatePrimaryMobileNum: "",
      studentSecondaryMobileNum: "",
      studentUpdateEmergencyMobileNum: "",
      studentUpdateParentMobileNum3: "",
      studentUpdateOfficeNum: "",
      studentUpdateResidenceNum: "",
      studentUpdateAddress: "",
      studentUpdateEmailId1: "",
      studentUpdateEmailId2: "",
      studentUpdateEmailId3: "",
      studentUpdateEmergencyContactPerson: "",
      studentUpdateExtraField1: "",
      studentUpdateExtraField2: "",
      studentUpdateExtraField3: "",
      studentUpdateExtraField4: "",
      studentUpdateExtraField5: "",
      studentUpdateSchoolFees: "",
      studentUpdateTuitionFees: "",
      studentUpdateTransportationFees: "",
      studentUpdateCanteenFees: "",
      studentUpdateBookFees: "",
      studentUpdateEventFee: "",
      studentUpdateUniformFee: "",
      studentUpdateRegistrationFees: "",
      studentUpdateAdmissionFees: "",
      studentUpdateSchoolTripeFees: "",
      studentUpdateStationaryFees: "",
      studentUpdateMedicalFees: "",
      studentUpdateSecurityDepositFees: "",
      studentUpdateGender: "",
      studentUpdateStudentRegistered: "",
      studentUpdateId: "",
      studentUpdateStudentPrimaryKey: "",
      SyncDataCss: "SyncData",
      selectedEpp: "",
      totalSchoolsCount: 0,
      showToPageCount: 0,
      pageOffset: 0,
      pageSize: 10,
      pageNo: 0,
      seleectedRowCount: 0,
      selectedData: [],
      columnDefs: [
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          width: 45,
          pinned: "left",
          headerName: "Select",
          hide: this.adminType !== ADMIN_TYPE.SUPERADMIN,
          resizable: false,
        },
        {
          headerName: "Merchant Name",
          field: "name",
          colId: "view",
          pinned: "left",
          width: 180,
          cellRenderer: (params) => this.renderMerchantName(params),
          resizable: true,
          sortable: true,
          unSortIcon: true,
        },
        {
          headerName: "Merchant ID",
          field: "merchantId",
          sortable: true,
          filter: true,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: "Student Data Provided",
          field: "schoolDataProvided",
          sortable: true,
          filter: true,
          width: 250,
          cellDataType: "string",
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },
        {
          headerName: "OTP Required",
          field: "otpRequired",
          sortable: true,
          filter: true,
          left: 450,
          cellDataType: "string",
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },
        {
          headerName: "Default Currency",
          field: "defaultCurrency",
          sortable: true,
          filter: true,
          left: 650,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },
        {
          headerName: "Category",
          field: "category",
          sortable: true,
          filter: true,
          left: 850,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },

        {
          headerName: "Student Profile Approval",
          field: "studentProfileApproval",
          sortable: true,
          filter: true,
          left: 1050,
          width: 250,
          cellDataType: "string",
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },

        {
          headerName: "Outstanding Fee",
          field: "outstandingFee",
          cellRenderer: (params) => this.setOutstandingFees(params.value),
          sortable: true,
          filter: true,
          left: 1300,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },
        {
          headerName: "Visa EPP Status",
          field: "visaStatus",
          filter: true,
          sortable: true,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
          cellRenderer: (params) => (params?.value),
        },
        {
          headerName: "Last Synced",
          field: "lastUpdatedTime",
          cellRenderer: (params) => getNotifictionDateFormat(params.value),
          sortable: true,
          filter: true,
          left: 1500, //getNotifictionDateFormat()
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
        },
        {
          headerName: "Refresh",
          field: "sync",
          colId: "view",
          pinned: "right",
          width: 100,
          cellRenderer: (params) => this.renderSyncCmpt(params),
          resizable: false,
        },
      ],
      rowSelection: "multiple",
      paginationPageSize: 10,
      rowData: [
        {
          schoolId: 0,
          studentId: "string",
          merchantId: "string",
          schoolName: "string",
          schoolPhoneNum: 0,
          firstName: "string",
          middleName: "string",
          lastName: "string",
          givenName: "string",
          emiratesId: "string",
          grade: "string",
          division: "string",
          dateOfBirth: "string",
          nationality: "string",
          productName: "string",
          outstandingAmount: "string",
          fatherName: "string",
          motherName: "string",
          parentId: "string",
          primaryMobileNum: "string",
          emergencyMobileNum: 0,
          parentMobileNum3: 0,
          officeNum: 0,
          residenceNum: 0,
          address: "string",
          emailId1: "string",
          emailId2: "string",
          emailId3: "string",
          emergencyContactPerson: "string",
          extraField1: "string",
          extraField2: "string",
          extraField3: "string",
          extraField4: "string",
          extraField5: "string",
          schoolFees: 0.0,
          tuitionFees: 0.0,
          transportationFees: 0.0,
          canteenFees: 0.0,
          bookFees: 0.0,
          eventFee: 0.0,
          uniformFee: 0.0,
          registrationFees: 0.0,
          admissionFees: 0.0,
          schoolTripeFees: 0.0,
          stationaryFees: 0.0,
          medicalFees: 0.0,
          securityDepositFees: 0.0,
          gender: "string",
          studentRegistered: false,
        },
      ],
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
    this.testCellRenderer = this.testCellRenderer.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }
  renderMerchantName = (params) => {
    return (
      <span
        style={{ cursor: "pointer" }}
        role="button"
        className="merchant-name-style"
        onClick={() => this.handleShow(params)}
        onKeyPress={(e) => {
          if (e.key === "Enter") this.handleShow(params);
        }}
        tabIndex="0"
      >
        {params.data[this.state.columnDefs[1].field]}
      </span>
    );
  };
  renderSyncCmpt = (params) => {
    return (
      <Button
        varient="link"
        className={this.state.SyncDataCss}
        disabled={this.adminType === ADMIN_TYPE.SALESADMIN}
        onClick={() => this.props.onSync(params)}
      />
    );
  };
  handleShow = (params) => {
    localStorage.setItem("globalMerchantId", params.data.merchantId);
    localStorage.setItem("superAdminSchoolName", params.data.name);
    localStorage.setItem("icon", params.data.icon);
    localStorage.setItem("schoolDataProvided", params.data.schoolDataProvided);
    this.context.navigateTo(ROUTES.STUDENT_DATA);
  };

  testCellRenderer() {
    let g =
      '<button class="glyphicon glyphicon-edit" onclick=' +
      this.editApp() +
      ">Edit</button>";
    return g;
  }

  setOutstandingFees(param) {
    if (param === true) {
      return "Enabled";
    }
    return "Disabled";
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  };

  onSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    const selectedRowCount = selectedRows.length;
    const selectedNodes = event.api.getSelectedNodes();
    this.setState({
      seleectedRowCount: selectedRowCount,
      selectedData: selectedNodes.map((node) => node.data),
    });
  };

  handleClearSelection = () => {
    this.gridApi.deselectAll();
  };

  handleOnboardMerchants = () => {
    this.props.onboardMerchants(this.state.selectedData, "visa");
    this.handleClearSelection();
  };

  render() {
    return (
      <LandingAGgridStyled headerSelected={this.state.seleectedRowCount}>
        <div className="ag-header-custom">
          <div className="d-flex">
            <div className="d-flex justify-content-between align-items-center gap-3">
              <BoxSelectedLogo />
              <Typography
                variant="h4"
                component="span"
                sx={{ color: colors.custom }}
              >
                {this.state.seleectedRowCount > 0 &&
                  `${this.state.seleectedRowCount} selected`}
              </Typography>
              <Button
                style={{ background: "none", border: "none", padding: 0 }}
                onClick={this.handleClearSelection}
              >
                <Typography
                  variant="h4"
                  component="span"
                  sx={{ color: colors.nonActive }}
                >
                  Cancel
                </Typography>
              </Button>
            </div>
          </div>
          <button
            style={{ background: "none", border: "none", padding: 0 }}
            className="d-flex justify-content-between align-items-center gap-1 cursor-pointer"
            onClick={this.handleOnboardMerchants}
          >
            <SideBarAddLogo bgColor={colors.primary} />
            <Typography
              variant="h4"
              component="span"
              sx={{ color: colors.primary, fontWeight: FONT_WEIGHT_BOLD }}
            >
              Onboard selected for Visa EPP
            </Typography>
          </button>
        </div>
        <AgGridReact
          columnDefs={this.state.columnDefs}
          overlayLoadingTemplate={this.state.overlayLoadingTemplate}
          rowData={this.props.studentDetails}
          rowSelection="multiple"
          onGridReady={this.onGridReady}
          rowHeight={51}
          onSelectionChanged={this.onSelectionChanged}
          rowStyle={{
            borderBottom: `1px solid ${colors.border}`,
          }}
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
            RowStyleModule,
          ]}
        />
      </LandingAGgridStyled>
    );
  }
}

LandingPageAGgrid.propTypes = {
  studentDetails: PropTypes.array,
  onSync: PropTypes.func,
};

export default LandingPageAGgrid;
